import { render, staticRenderFns } from "./UsageStatisticsReferenceTable.vue?vue&type=template&id=3c9199e5&"
import script from "./UsageStatisticsReferenceTable.vue?vue&type=script&lang=ts&"
export * from "./UsageStatisticsReferenceTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports